import { storeOrUpdateAdvertiserTask } from '@/api/advertiser'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import { getKvData, getMediaCorporationAdvertiser, getAdvertiserTask, updateAdvertiserTask, retryAdvertiserChildrenTask, getWorkers, verifyMediaCorporations } from '@/api/open'


export default {
    components: {
        AdvSelect
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        media: {
            type: String,
            required: true
        },
        showCreateForm: {
            type: Boolean,
            required: true
        },
        show_type: {
            type: Number,
            required: false,
            default: 1 
        },
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            advs: {},
            model: {
                advertiser_id: null,
                media_corporations: [],
                num:1,
                remark:null,
            },
            loading: false,
            actionName: '操作',
            timeout: null,
            rules: {
                'advertiser_id': [{ required: true, message: '请选择广告主', trigger: 'change' }],
                'media_corporations': [{ required: true, message: '请选择媒体主体', trigger: 'change' }],
                'num': [{ required: true, message: '请选择主体广告主数量', trigger: 'change' }],
                'remark': [{ required: true, message: '请填写统一备注', trigger: 'change' }],
                'pay_type': [{ required: true, message: '请选择付费类型', trigger: 'change' }],
            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            currentAdvId: null,
            current: 0,
            steps: [
                { title: '选择媒体主体' },
                { title: '配置广告主' },
                { title: '任务结果' },
            ],
            advertisers: [], //广告主
            media_corporations: [], //媒体主体
            corporationCountMap: {},
            task: {},
            workers: [],
            showBatchModal: false,   // 批量导入弹窗显示状态
            batchInput: '',          // 批量输入的文本
            batchLoading: false,     // 弹窗确认加载状态
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '新建'
        },
    },
    mounted() {
        //此处开始获取kvData
        let type = 4
        if (this.params.platform_app_type == 3) {
            type = 102
        }
        this.model.pay_type = this.params.pay_type;
        getKvData({type:type, corporation_id: this.params.corporation_id, platform_id: this.params.platform_id, platform_type:this.params.p_type, platform_app_type:this.params.platform_app_type, pay_type:this.model.pay_type}).then(res => {
            this.media_corporations = res.data.list || []
            this.corporationCountMap = res.data.corporation_new_count_list || {}
        })

        getWorkers().then(res => {
            this.workers = res.data.list
        })

        // console.log('this.params.ids', this.params.id) 
        this.$set(this.model, 'advertiser_id', [this.params.ad_id])
        this.getData()
    },
    watch: {
    },
    created() {},
    methods: {
        getData() {
            this.loading = true
            getAdvertiserTask({ advertiser_id: this.model.advertiser_id[0], show_type:this.show_type, task_id:this.params.id }).then(res => {
                this.loading = false
                this.task = res.data || {}
                
                if (this.task.id) {
                    this.current = this.task.step > 1 ? this.task.step - 1 : 0
                } else {
                    this.current = 0
                }
                console.log('任务详情', this.task)
            }).catch(() => {
                this.loading = false
            })
        },
        restart() {
            this.loading = true
            updateAdvertiserTask({ task_id: this.task.id }).then(() => {
                this.loading = false
                this.getData()
            }).catch(() => {
                this.loading = false
            })
        },
        retry(item) {
            this.loading = true
            // console.log('aa', item)
            retryAdvertiserChildrenTask({ children_task_id: item.id }).then(() => {
                this.loading = false
                this.getData()
            }).catch(() => {
                this.loading = false
            })
        },
        changeAdvs() {
            this.$nextTick(() => {
                if (this.currentAdvId !== this.model.ids[0]) {
                    this.$set(this.model, 'related_product', {
                        product_setting: 'SINGLE'
                    })
                }
            })
            this.$nextTick(this.init)
        },
        init() {
            // const advertiserFilter = { advertiser_id: this.model.ids[0] }
            if (!this.model.media_corporations) {
                return false
            }
         
            this.loading = true
            getMediaCorporationAdvertiser({ media_corporations: this.model.media_corporations, num: this.model.num, is_new:true }).then(res => {
                let advertisers = {}
                this.advs = res.data || []
                if (this.advs) {
                    for (const name in this.advs) {
                        // console.log('name', name, this.advs[name])
                        advertisers[name] = []
                        Object.values(this.advs[name]).forEach( (item) => {
                            advertisers[name].push(item.id)
                        })
                    }
                    this.advertisers = advertisers
                }
                this.loading = false
                // console.log( this.advertisers)
            }).catch(() => {
                this.loading = false
            })
           
        },
        next() {
            // console.log('this.current', this.current)
            const pattern = /^[\u4e00-\u9fa5a-zA-Z0-9-]+$/;
            if (this.model.pt_name && !pattern.test(this.model.pt_name)) {
                this.$message.error('推广链名称只能输入汉字、字母、数字和减号');
                return false
            }

            // 添加漂移媒体主体验证
            const media_corporations = this.model.media_corporations || []
            if (media_corporations.length > 0) {
                this.loading = true
                verifyMediaCorporations({ media_corporations: this.model.media_corporations }).then(res => {
                    this.loading = false
                    // 检查是否有漂移
                    if (res.data && res.data.has_drift === true) {
                        // 构建提示信息
                        const driftList = res.data.list || []
                        let message = '检测到以下主体漂移：\n'
                        driftList.forEach(item => {
                            message += `${item} \n`
                        })
                        message += '\n请先处理主体漂移问题后再继续创建任务。'
                        
                        this.$modal.error({
                            title: '漂移主体检测',
                            content: message,
                            okText: '知道了'
                        })
                        return
                    }
                    this.validateForm()
                }).catch(() => {
                    this.loading = false
                    this.validateForm()
                })
                return
            }

            this.validateForm()
            // // 当前步骤是 0，开始获取对应的媒体广告主
            // if (this.current === 0 ) {
            //     this.init()
            // }
       
            // this.$refs.form.validate(valid => {
            //     if (!valid) {
            //         return false
            //     }
            //     this.current++
            // })
        },
        prev() {
            this.$refs.form.clearValidate()
            this.current--
            this.advertisers = []

            // 回到第一步时重新拉
            if (this.current === 0) {
                this.fetchKvData()
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
            })

            this.$message.destroy()
            this.storeOrUpdate()
        },
        storeOrUpdate() {
            this.loading = true
            let json = Object.assign({}, this.model)
            json.advs = this.advs
            json.advertisers = this.advertisers
            json.task_type = 1
            if (this.params.platform_app_type == 3) {
                json.task_type = 2
            }
            console.log('准备提交：', this.media, json)

            storeOrUpdateAdvertiserTask(json).then(() => {
                this.loading = false
                this.current++
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$emit('success')
            this.$emit('update:showCreateForm', false)
        },
        createAdvertiserTask()
        {
            this.current = 0
        },
        copy(str) {
            this.$helper.clipboard(str)
            this.$message.success('复制成功')
        },
        changePayType(pey_type) {
            getKvData({type:102, corporation_id: this.params.corporation_id, platform_id: this.params.platform_id, platform_type:this.params.p_type, platform_app_type:this.params.platform_app_type, pay_type:pey_type}).then(res => {
                this.media_corporations = res.data.list || []
                this.corporationCountMap = res.data.corporation_new_count_list || {}
            })
        },
        // 批量导入处理 
        handleBatchImport() {
            if (!this.batchInput.trim()) {
                this.$message.warning('请输入媒体主体');
                return;
            }
            this.batchLoading = true;

            // 1. 分割输入文本：支持换行、逗号、空格
            let inputText = this.batchInput.trim();
            let keywords = inputText.split(/[,\n\s]+/).filter(s => s.trim() !== '');
            // 去重
            keywords = [...new Set(keywords)];

            // 2. 获取可用的媒体主体列表
            const available = this.media_corporations; // 已从接口获取的全部主体

            // 3. 模糊匹配：找出所有在 available 中存在的项（支持大小写不敏感）
            const matched = [];
            const notMatched = [];
            keywords.forEach(keyword => {
                // 完全匹配优先
                let found = available.find(item => item === keyword);
                if (!found) {
                    // 不区分大小写的包含匹配（可根据需求调整）
                    found = available.find(item => item.toLowerCase().includes(keyword.toLowerCase()));
                }
                if (found) {
                    matched.push(found);
                } else {
                    notMatched.push(keyword);
                }
            });

            // 4. 去重后添加到 model.media_corporations
            const current = this.model.media_corporations || [];
            const newSelections = [...new Set([...current, ...matched])];
            this.model.media_corporations = newSelections;

            // 5. 提示
            if (matched.length > 0) {
                this.$message.success(`成功匹配并添加 ${matched.length} 个媒体主体`);
            }
            if (notMatched.length > 0) {
                this.$message.warning(`未找到匹配的主体：${notMatched.join('、')}`);
            }

            // 清空弹窗状态
            this.batchInput = '';
            this.showBatchModal = false;
            this.batchLoading = false;
        },
        fetchKvData() {
            let type = 4
            if (this.params.platform_app_type == 3) {
              type = 102
            }
        
            return getKvData({
              type: type,
              corporation_id: this.params.corporation_id,
              platform_id: this.params.platform_id,
              platform_type: this.params.p_type,
              platform_app_type: this.params.platform_app_type,
              pay_type: this.model.pay_type
            }).then(res => {
              this.media_corporations = res.data.list || []
              this.corporationCountMap = res.data.corporation_new_count_list || {}
            })
        },
        validateForm() {
            // 当前步骤是 0，开始获取对应的媒体广告主
            if (this.current === 0 ) {
                this.init()
            }

            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.current++
            })
        }
    }
}
